import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AdminService, Booking, Equipment } from '@app/core/services/admin.service';
import { FormsModule } from '@angular/forms';
import { ToastService } from '@app/core/services/toast.service';
import { BookingsListComponent } from './bookings-list.component';
import { PriceCalculationsComponent } from './price-calculations.component';
import { catchError, retry, timeout, finalize } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, BookingsListComponent, PriceCalculationsComponent],
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  activeTab: 'bookings' | 'equipment' | 'pricing-calculations' = 'bookings';
  
  // Equipment
  equipment: Equipment[] = [];
  equipmentLoading = true;

  constructor(
    private adminService: AdminService,
    private toastService: ToastService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadEquipment();
  }

  // Tab Management
  switchTab(tab: 'bookings' | 'equipment' | 'pricing-calculations') {
    this.activeTab = tab;
    if (tab === 'equipment' && this.equipment.length === 0 && !this.equipmentLoading) {
      this.loadEquipment();
    }
  }

  // Booking Management
  onSelectBooking(booking: Booking) {
    this.router.navigate(['/admin/booking', booking.id]);
  }

  // Equipment Management
  loadEquipment() {
    this.equipmentLoading = true;
    this.adminService.getAllEquipment()
      .pipe(
        timeout(5000),
        retry({ count: 2, delay: 1000 }),
        catchError(() => {
          this.toastService.error('Fehler beim Laden des Equipments');
          return of([] as Equipment[]);
        }),
        finalize(() => {
          this.equipmentLoading = false;
        })
      )
      .subscribe((equipment) => {
        this.equipment = equipment;
      });
  }

  newEquipment() {
    // Navigation happens via routerLink
  }

  editEquipment(id: string) {
    // Encode ID to handle slashes (e.g., equipment/34-A -> equipment%2F34-A)
    const encodedId = encodeURIComponent(id);
    this.router.navigate(['/admin/equipment', encodedId]);
  }
}
